<div class="map-wrapper">
    <div class="map-loader" *ngIf="dataList[0]?.isLoading">
        <div class="loader"></div>
        <div class="spinner"></div>
    </div>
        <google-map *ngIf="dataList[0]?.showMap && dataList[0]?.mapCenter" height="200px" width="100%" [zoom]="zoom"
            [center]="dataList[0].mapCenter" [options]="{
            zoomControl: true,
            fullscreenControl: true,
            disableDefaultUI: true
    }">
            <map-polyline *ngIf="dataList[0].polylinePath" [path]="dataList[0].polylinePath"
                [options]="polylineOptions">
            </map-polyline>
            <ng-container *ngFor="let m of dataList[0].markers">
                <map-marker #marker="mapMarker" [position]="m.position" [options]="m.options"
                    (mapClick)="openInfo(marker, iw)"
                    (mapMouseover)="openInfo(marker, iw)"
                    (mapMouseout)="closeInfo(iw)">
                </map-marker>
                <map-info-window #iw="mapInfoWindow" [options]="infoOptions">
                    <div class="load-popover__content">
                        <div class="load-popover__header">
                            <span class="load-popover__title">{{ m.isPickup ? 'Pick-up' : 'Drop-off' }}</span>
                            <button type="button" class="load-popover__close" matTooltip="Close"
                                aria-label="Close" (click)="iw.close()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <div class="load-popover__route">
                            <div class="load-popover__route-item">
                                <mat-icon [style.color]="m.isPickup ? '#28a745' : '#d93025'">place</mat-icon>
                                <div>
                                    <strong>{{ m.address || '--' }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </map-info-window>
            </ng-container>
        </google-map>
</div>